var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "green-tick-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZH.Screen.Web.Services-Utilization-Management-Services",
    transform: "translate(-1020, -1810)",
    fill: "#1E8F32",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "green-tick-icon",
    transform: "translate(1020, 1810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37258562,0 0,5.37258562 0,12 C0,18.6274143 5.37258562,24 12,24 C18.6274143,24 24,18.6274143 24,12 C23.9929688,5.3755488 18.6245014,0.00708148309 12,0 Z M18.6060193,8.32029063 L10.034562,16.8917479 C9.6998238,17.2263856 9.15726163,17.2263856 8.82257374,16.8917479 L5.39398072,13.4631549 C5.05346689,13.1342929 5.04402491,12.5916805 5.37288698,12.2511666 C5.70174903,11.9106528 6.2443614,11.9012108 6.58487528,12.2300728 C6.59200695,12.2370037 6.59903823,12.2439847 6.60596902,12.2511666 L9.42856783,15.0737655 L17.3940309,7.10830233 C17.7345448,6.77944028 18.2771572,6.78888225 18.6060193,7.12934588 C18.9268456,7.46152268 18.9268456,7.98811383 18.6060193,8.32029063 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/green-tick-icon.c479bfd4d20458cd4d48b69f29aa84d2.svg";
export { ForwardRef as ReactComponent };